import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TTextFolder, TTextFolderTreeItem } from 'stores/TextFoldersStore';
import { useStores } from '../../services/useStore';

export interface ITextFolderSelect {
  folderId: number;
  excludeId?: number;
  excludeIn?: number;
  addRoot?: boolean;
  action: (value: number) => void;
}

const TextFolderSelect: React.FC<ITextFolderSelect> = observer(
  ({ folderId, excludeId, excludeIn, action, addRoot = false }) => {
    const { t } = useTranslation();
    const { textFolderStore } = useStores();
    const [folder, setFolder] = useState(folderId);
    const [folders, setFolders] = useState<TTextFolder[]>();

    useEffect(() => {
      let fId: number = folderId;
      const list: TTextFolderTreeItem[] = textFolderStore.getFoldersByParent(0);
      const foldersData: TTextFolder[] = [];
      const getParents = (data: TTextFolderTreeItem[], level: number = 0) => {
        data.forEach((folderData: TTextFolderTreeItem) => {
          if (folderData.folder.folder_id === excludeId) return;
          if (!fId) fId = folderData.folder.folder_id;
          foldersData.push({ ...folderData.folder, level });
          if (folderData.folder.folder_id === excludeIn) return;
          if (folderData.childs.length) getParents(folderData.childs, level + 1);
        });
      };
      setFolder(fId);
      getParents(list);
      setFolders(foldersData);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [folderId]);

    return (
      <FloatingLabel controlId="textFolder" label={t('folder.folder')} className="mb-3">
        <Form.Select
          aria-label={t('folder.folder')}
          required
          size="lg"
          value={folder}
          onChange={(e) => action(+e.currentTarget.value)}
        >
          {addRoot ? (
            <option key={0} value={0}>
              🗁 {t('folder.root')}
            </option>
          ) : (
            ''
          )}
          {folders &&
            folders.map((folderData: TTextFolder) => (
              <option key={folderData.folder_id} value={folderData.folder_id}>
                {folderData.level ? ''.padEnd(folderData.level * 2, ' ') + '┗╸🗁 ' : '🗁 '}
                {folderData.folder_name}
              </option>
            ))}
        </Form.Select>
      </FloatingLabel>
    );
  }
);
export default TextFolderSelect;
